export enum Gesture {
    ONE_FINGER = 1,
    TWO_FINGERS = 2,
}

export interface Position {
    x: number;
    y: number;
}

export interface PanEvent {
    isFinal: boolean;
    deltaX: number;
    deltaY: number;
}

export interface PinchEvent {
    scale: number;
    focalPoint: Position;
}
